import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {ListGroupItem} from 'reactstrap';

import Link from '../../../components/Link/Link.jsx';
import Since from '../../../../shared/components/Moment/Since.jsx';
import NotificationLogo from './NotificationLogo.jsx';

import api from '../../../../api.js';

export default class Notification extends Component {
  static propTypes = {
    notification: PropTypes.object.isRequired,
    loadNotification: PropTypes.func.isRequired,
  };

  seeNotification(notification, loadNotification) {
    if(!notification.seen) {
      notification.seen = true;
      api.notifications.patch(notification).then(function () {
        loadNotification();
      });
    }
  }

  render() {
    return (
      <Link
        to={this.props.notification.link}
        onClick={() => this.seeNotification(this.props.notification, this.props.loadNotification)}
      >
        <ListGroupItem className={(!this.props.notification.seen ? 'unseen' : '') + ' notification'}>
          <div>
            <NotificationLogo type={this.props.notification.type} />
            {this.props.notification.message}
          </div>

          <p>{this.props.notification.created_at}</p>
          
          <Since className="since" date={this.props.notification.created_at}/>
        </ListGroupItem>
      </Link>
    );
  }
}